import React from 'react';
import Step1TimeChange from './Step1TimeChange';
import Step1Main from './Step1Main';

const Step1User = props => {
  const {
    updateState,
    appointment,
    isTimeChange,
    isListingContact,
    keepOriginalAppointment,
    originalAppointment,
    isMobile,
    currentStep,
  } = props;

  return (
    <>
      {(!isMobile || (isMobile && currentStep === 0)) && (
        <>
          {isTimeChange ? (
            <Step1TimeChange
              {...props}
              updateState={updateState}
              appointment={appointment}
              originalAppointment={originalAppointment}
              isListingContact={isListingContact}
              keepOriginalAppointment={keepOriginalAppointment}
            />
          ) : (
            <Step1Main {...props} />
          )}
        </>
      )}
    </>
  );
};

export default Step1User;
